<template>
  <div>
    <!-- 附加服务 -->
    <el-dialog :title="$t('message.additionalServices')" :close-on-click-modal="false"
      :visible.sync="$parent.optionsDialogVisible" width="800px" center>
      <div class="option">
        <!-- 列表 -->
        <div class="table">
          <ol>
            <!--附加服务选择  -->
            <li class="flex15">
              {{ $t("message.additionalServiceOptions") }}
            </li>
            <!--数量  -->
            <li>
              {{ $t("message.number") }}
            </li>
            <!--实际收费标准  -->
            <li class="flex15">{{ $t("message.actualCharges") }}</li>
            <!--预计费用  -->
            <li>{{ $t("message.estimatedCost") }}(元)</li>
          </ol>

          <ul v-for="(item, index) in optionsList" :key="index">
            <!--附加服务选择  -->
            <li class="flex15">
              <div class="checkbox" v-if="item.edit">
                <el-checkbox v-model="item.checked">({{ index + 1 }}) {{ item.name }}</el-checkbox>
              </div>
              <div class="checkbox" v-else>
                <el-checkbox v-model="item.checked"></el-checkbox>
                <div class="input">
                  <el-input v-model="item.name" size="small" onfocus="this.select()"></el-input>
                </div>
              </div>
            </li>
            <!--数量  -->
            <li>
              <el-input v-if="item.price_type == 0" v-model="item.num" size="small" onfocus="this.select()"></el-input>
            </li>
            <!--实际收费标准  -->
            <li class="flex15">
              <div class="template">
                <div class="input">
                  <el-input v-model="item.price" size="small" onfocus="this.select()"></el-input>
                </div>
                {{ item.unit }}
              </div>
            </li>
            <!--预计费用  -->
            <li>
              <span class="total">
                <!-- 计算方式 当个 -->
                <span v-if="item.price_type == 0">{{
                  item.checked ? ceil(item.price * item.num) : 0
                }}</span>
                <!-- 计算方式 % -->
                <span v-else>
                  <!-- 各种状态的计算方式 -->
                  <span>
                    {{
                      item.checked
                        ? ceil(detail.goodsTotal * (item.price / 100), 2)
                        : 0
                    }}
                  </span>

                </span>
              </span>
              <el-button size="mini" type="success" class="dark fr" v-if="!item.edit" @click="delItem(index)">
                {{ $t("message.delete") }}
              </el-button>
            </li>
          </ul>
        </div>
        <!-- 操作 -->

        <div class="operation">
          <el-button size="mini" type="success" @click="add">
            {{ $t("message.add") }}
          </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.optionsDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    detail: { type: Object },
    status: { type: Number },
  },
  data() {
    return {
      optionsList: [],
      val: "",
    };
  },
  created() {
    let datas = {
      user_id: this.$route.query.userID
    }
    this.$api.orderApi.orderOptionList(datas).then((res) => {
      this.optionsList = res.data;
      if (this.detail.option != false && this.detail.option != null) {
        this.detail.option.forEach((item) => {
          let flag = this.optionsList.every((items) => item.name != items.name);
          if (flag) {
            this.optionsList.push(item);
          }
          this.optionsList.forEach((items) => {
            if (item.name == items.name) {
              items.num = item.num;
              items.checked = item.checked;
              items.price = item.price;
              items.total = item.total;
            }
          });
        });
      }
    });
  },
  methods: {
    add() {
      this.optionsList.push({
        auto_calculate: 0,
        checked: false,
        edit: false,
        is_overstep: 0,
        name: "",
        price_type: 0,
        price: "",
        num: "",
      });
    },
    delItem(i) {
      this.optionsList.splice(i, 1);
    },
    // 保存
    save() {
      let options = [];
      this.optionsList.forEach((item) => {

        if (item.checked && item.num > 0 && item.price_type != 1) {
          options.push(item);
        } else if (item.checked) {
          item.num = 1
          options.push(item);
        }
      });
      this.$parent.orderDetail[this.$parent.i].option = options;
      this.$parent.optionsDialogVisible = false;
      this.$parent.commodityTotal();
    },
  },
};
</script>
<style lang='scss' scoped>
.table {
  margin-bottom: 20px;

  ol {
    display: flex;
    height: 40px;
    background: #f8f8f8;
    border-radius: 4px 4px 0px 0px;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
    }
  }

  ul {
    display: flex;
    padding: 10px 0;

    .total {
      width: 70%;
      text-align: center;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex2 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .checkbox {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;

    .input {
      width: 160px;
      margin-left: 10px;
    }
  }

  .template {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;

    .input {
      width: 140px;
      margin-right: 10px;
    }
  }
}
</style>